import { Col, FormLabel, Row } from "react-bootstrap";
import { IFieldEditor } from "../../../../models/Interfaces";

const EmbeddedEditor = (props: IFieldEditor) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;
    props.onValueChange(props.property.Id, value);
  }

  return (
    <>
      <Row className="m-0 p-0">
        <Col md={12} xl={6} className="m-0 p-0 mt-md-3">
          <FormLabel>{props.property.DisplayLabel}</FormLabel>
          <textarea
            rows={5}
            title="add embedded code"
            value={props.property.PublishedValue ?? ""}
            onChange={handleChange}
            className="form-control">
          </textarea>
        </Col>
        <Col md={12} xl={6} className="m-0 ps-3 p-0 mt-md-3">
          <FormLabel>Embed preview (if available)</FormLabel>
          { props.property.PublishedValue && (
            <div className="embed-preview" dangerouslySetInnerHTML={{ __html: props.property.PublishedValue}}>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
}

export default EmbeddedEditor;